module.exports = __webpack_public_path__ + "static/media/janelle-monae-dirty-computer-album-2018-billboard-embed@2x.de7f6c6a.png";